import { useEffect, useState } from "react"

export const DASHBOARD_REFRESH_MS = 3 * 60_000

export function useDashboardActive() {
	const [active, setActive] = useState(
		() => document.visibilityState === "visible" && document.hasFocus(),
	)
	useEffect(() => {
		const update = () =>
			setActive(document.visibilityState === "visible" && document.hasFocus())
		window.addEventListener("focus", update)
		window.addEventListener("blur", update)
		document.addEventListener("visibilitychange", update)
		update()
		return () => {
			window.removeEventListener("focus", update)
			window.removeEventListener("blur", update)
			document.removeEventListener("visibilitychange", update)
		}
	}, [])
	return active
}
